import { DoorClosed, Phone, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE, TEL_HREF } from "@/siteConfig";

export const DoorOpening = () => (
  <section
    id="apertura-porte"
    data-testid="door-opening-section"
    className="scroll-mt-24 border-y border-amber-400/20 bg-gradient-to-r from-amber-400/[0.10] via-[#0D1119] to-amber-400/[0.05] py-14 sm:py-16"
  >
    <div className="mx-auto flex max-w-5xl flex-col items-center gap-8 px-4 sm:px-6 md:flex-row md:items-center md:gap-10">
      <Reveal className="flex-1 text-center md:text-left">
        <div className="mx-auto md:mx-0 flex h-14 w-14 items-center justify-center rounded-2xl border border-amber-400/30 bg-amber-400/10 text-amber-400">
          <DoorClosed className="h-7 w-7" />
        </div>
        <h2 className="mt-5 font-display text-2xl sm:text-3xl font-bold tracking-tight text-zinc-100">
          Chiuso fuori casa? Porta bloccata?
        </h2>
        <p className="mt-4 max-w-xl text-sm sm:text-base leading-relaxed text-zinc-400">
          Apertura porte a Roma e provincia, anche di notte: porte di casa,
          porte blindate, chiavi dimenticate o spezzate. Al telefono descrivi
          la situazione e verifichiamo subito la disponibilità del servizio.
        </p>
        <a
          href="/apertura-porte-roma"
          data-testid="door-opening-page-link"
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-400 transition-colors hover:text-amber-300"
        >
          Pagina dedicata: apertura porte Roma
          <ArrowRight className="h-4 w-4" />
        </a>
      </Reveal>
      <Reveal delay={0.1} className="w-full md:w-auto">
        <a
          href={TEL_HREF}
          data-testid="door-opening-call-button"
          className="flex w-full md:w-auto items-center justify-center gap-3 whitespace-nowrap rounded-full bg-amber-400 px-9 py-4 text-base font-extrabold uppercase tracking-wide text-zinc-950 transition-colors hover:bg-amber-300 active:scale-[0.98]"
        >
          <Phone className="h-5 w-5" />
          Chiama ora — {SITE.phoneDisplay}
        </a>
      </Reveal>
    </div>
  </section>
);
